 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		13: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		13: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"a9a7754c","3":"cb1608f2","4":"f86019f1a734a639b21e9eccb59d271c5ff4131a","5":"a5d49e85370c69451a9edaac07d901884183c210","6":"0ec173a1b1b21790288fb5995c452edfed7f6edb","7":"05df20fa7e598882481075c3803c4d8311485524","8":"3e9a57d4d4051f05e9af6fc32c82d56ca5d45335","9":"91dc5e5ebd9b7a3007b05cda34500871b3b8ad69","10":"95bac74a893daf75ff47bf4180741a7a2a7b3e9b","11":"b7ad04a25477a86ea06557da3cc809988a0b6f9d","12":"93fca94179092ffd0498ed7ca9d50f8cc19c99e3","15":"component---src-pages-404-js","16":"component---src-pages-about-us-js","17":"component---src-pages-careers-js","18":"component---src-pages-contact-js","19":"component---src-pages-cs-blog-jak-vybrat-agenturu-na-vyvoj-aplikaci-js","20":"component---src-pages-cs-blog-js","21":"component---src-pages-cs-blog-moderni-technologie-pro-retail-audit-js","22":"component---src-pages-cs-blog-modernizace-php-aplikaci-1-historie-php-js","23":"component---src-pages-cs-blog-modernizace-php-aplikaci-2-duvody-k-aktualizaci-js","24":"component---src-pages-cs-blog-modernizace-php-aplikaci-3-posouzeni-php-projektu-js","25":"component---src-pages-cs-blog-novy-plugin-neon-nette-support-js","26":"component---src-pages-cs-blog-oceneni-v-ramci-european-customer-centricity-awards-js","27":"component---src-pages-cs-blog-pivonuv-beh-2021-js","28":"component---src-pages-cs-blog-pivonuv-beh-2023-js","29":"component---src-pages-cs-blog-podcast-o-aplikaci-springaudit-js","30":"component---src-pages-cs-blog-sportovni-den-2022-js","31":"component---src-pages-cs-blog-sportovni-odpoledne-na-czu-js","32":"component---src-pages-cs-blog-technicky-slovnicek-project-management-js","33":"component---src-pages-cs-index-js","34":"component---src-pages-cs-kariera-js","35":"component---src-pages-cs-kontakt-js","36":"component---src-pages-cs-o-nas-js","37":"component---src-pages-cs-reference-js","38":"component---src-pages-cs-sluzby-js","39":"component---src-pages-cs-sluzby-sprava-php-aplikaci-js","40":"component---src-pages-de-index-js","41":"component---src-pages-de-karriere-js","42":"component---src-pages-de-kontakt-js","43":"component---src-pages-de-referenzen-js","44":"component---src-pages-de-was-wir-tun-js","45":"component---src-pages-de-wir-uber-uns-js","46":"component---src-pages-index-js","47":"component---src-pages-our-work-js","48":"component---src-pages-services-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"03ded4120374885de546","2":"23eb02bb95c00c97e46d","3":"99898bc67ed8ba7087f3","4":"6931cee17fc076c0156c","5":"670e39171c4a2abe1562","6":"e09361deeccd8cc381a2","7":"66dc3799b2ae7afd118a","8":"fef5655b63cc378ef294","9":"ee8569bcd6bfb1bc683e","10":"b290aac8fb52ff0c3c61","11":"f00e231808263ff3b827","12":"04ca2758bd18ad78550f","15":"fc140b4777916968bf33","16":"812e13b639036952a34b","17":"ad2e436b283cc7d086bd","18":"c96f29bbe9032df10abe","19":"7282cc8b61baa92ea7c3","20":"42ecfbc9bcdaae812191","21":"263c8e2a6aff58019b9a","22":"0946458adbe3ac635c03","23":"9485d2acb7b471d5f75e","24":"9bc55089037ff881bde3","25":"b025074d4f7a64642b76","26":"d44d5cb7bc889e41d921","27":"4cf75f58e34443e45ca4","28":"32da262944f7302c3027","29":"9b107fec710cfcaa4984","30":"29edd4819adfac1338d5","31":"ffdaea8fcb86e476e7c3","32":"e37d06758bcfe031ab22","33":"550c03cd425c74a69aba","34":"bdffe81e98fe86b308ae","35":"f30608bbe5d57500333f","36":"cc0bba0cf8e5ff7b62db","37":"2e85ef4c00b2c292513d","38":"8221df7603030c939f81","39":"590385910dd3a00b973b","40":"476c9baceec5b34150c8","41":"82502b4773c73c6e0672","42":"c6ac35d46eca4e2891fa","43":"cca7c64fc369cad59cb8","44":"2926949e1e2d0decf9af","45":"25aa3e8dfc2c0456e1c3","46":"1d4c6e819c612c8aa43b","47":"2cb3527960e3d28560e3","48":"55d1cfd02b5106e6a1f1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"a9a7754c","3":"cb1608f2","4":"f86019f1a734a639b21e9eccb59d271c5ff4131a","5":"a5d49e85370c69451a9edaac07d901884183c210","6":"0ec173a1b1b21790288fb5995c452edfed7f6edb","7":"05df20fa7e598882481075c3803c4d8311485524","8":"3e9a57d4d4051f05e9af6fc32c82d56ca5d45335","9":"91dc5e5ebd9b7a3007b05cda34500871b3b8ad69","10":"95bac74a893daf75ff47bf4180741a7a2a7b3e9b","11":"b7ad04a25477a86ea06557da3cc809988a0b6f9d","12":"93fca94179092ffd0498ed7ca9d50f8cc19c99e3","15":"component---src-pages-404-js","16":"component---src-pages-about-us-js","17":"component---src-pages-careers-js","18":"component---src-pages-contact-js","19":"component---src-pages-cs-blog-jak-vybrat-agenturu-na-vyvoj-aplikaci-js","20":"component---src-pages-cs-blog-js","21":"component---src-pages-cs-blog-moderni-technologie-pro-retail-audit-js","22":"component---src-pages-cs-blog-modernizace-php-aplikaci-1-historie-php-js","23":"component---src-pages-cs-blog-modernizace-php-aplikaci-2-duvody-k-aktualizaci-js","24":"component---src-pages-cs-blog-modernizace-php-aplikaci-3-posouzeni-php-projektu-js","25":"component---src-pages-cs-blog-novy-plugin-neon-nette-support-js","26":"component---src-pages-cs-blog-oceneni-v-ramci-european-customer-centricity-awards-js","27":"component---src-pages-cs-blog-pivonuv-beh-2021-js","28":"component---src-pages-cs-blog-pivonuv-beh-2023-js","29":"component---src-pages-cs-blog-podcast-o-aplikaci-springaudit-js","30":"component---src-pages-cs-blog-sportovni-den-2022-js","31":"component---src-pages-cs-blog-sportovni-odpoledne-na-czu-js","32":"component---src-pages-cs-blog-technicky-slovnicek-project-management-js","33":"component---src-pages-cs-index-js","34":"component---src-pages-cs-kariera-js","35":"component---src-pages-cs-kontakt-js","36":"component---src-pages-cs-o-nas-js","37":"component---src-pages-cs-reference-js","38":"component---src-pages-cs-sluzby-js","39":"component---src-pages-cs-sluzby-sprava-php-aplikaci-js","40":"component---src-pages-de-index-js","41":"component---src-pages-de-karriere-js","42":"component---src-pages-de-kontakt-js","43":"component---src-pages-de-referenzen-js","44":"component---src-pages-de-was-wir-tun-js","45":"component---src-pages-de-wir-uber-uns-js","46":"component---src-pages-index-js","47":"component---src-pages-our-work-js","48":"component---src-pages-services-js"}[chunkId]||chunkId) + "." + {"0":"78d9051f8f08f8ebe169","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
